module.exports = __webpack_public_path__ + "media/applicants/device_signup_6-fr-e8b1aed8.webp";